module.exports = __webpack_public_path__ + "static/media/twitter.dd90206d.svg";